import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../API/apiClient";

export const getItemGroup = createAsyncThunk(
    'ItemPage/fetchItemGroup',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('ItemPage/GetItemGroup');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );


  export const getItem = createAsyncThunk(
    'ItemPage/fetchItem',
    async ({ grpCode }, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`ItemPage/GetItemByGroup?grpCode=${grpCode}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  
  export const GetItembyPasting = createAsyncThunk(
    'ItemPage/fetchItembypaste',
    async ({ ItemCodes }, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`ItemPage/GetItembyPasteItems?itemcode=${ItemCodes}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );


  export const getCartItemApi = createAsyncThunk(
    'ItemPage/fetchCartItem',
    async (_ , { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('ItemPage/GetCartItem');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  

  export const getItembySearchWithTotal = createAsyncThunk(
    'ItemPage/fetchItembySearchWithTotal',
    async ({ searchText, pageNumber, pageSize }, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('ItemPage/GetItemBySearch', {
            params: { searchText, pageNumber, pageSize  }  
          });
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );


  export const getItembySearchTable = createAsyncThunk(
    'ItemPage/fetchItembySearchTable',
    async ({ searchText, pageNumber, pageSize }, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('ItemPage/GetItemTableSearch', {
            params: { searchText, pageNumber, pageSize  }  
          });
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );


  export const GetPriceList = createAsyncThunk(
    'ItemPage/GetPriceList',
    async ({ ItemCode}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('ItemPage/GetPriceListByItem', {
            params: { ItemCode }  
          });
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  
  export const GetPrintData = createAsyncThunk(
    'ItemPage/PrintReport',
    async ({ docEntrys, orderType}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`PrintReport/ReportData?DocEntry=${docEntrys}&DocType=${orderType}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );


  export const PostCartItemApi = createAsyncThunk(
    'ItemPage/postCartItem',  
    async (tableBody, { rejectWithValue }) => {
      try {
        const response = await apiClient.post('ItemPage/InsertOrUpdateCartItems',tableBody);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error Posting Data');
      }
    }
  );


  export const removeItemInTable = createAsyncThunk(
    'ItemPage/RemoveItem',  
    async (_, { rejectWithValue }) => {
      try {
        const response = await apiClient.post('ItemPage/RemoveCartItems');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error Posting Data');
      }
    }
  );

  export const SoPostApi = createAsyncThunk(
    'Checkout/SoPost',  
    async (tableBody, { rejectWithValue }) => {
      try {
        const response = await apiClient.post('CheckoutPage/InsertSalesOrder',tableBody);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error Posting Data');
      }
    }
  );

  export const SqPostApi = createAsyncThunk(
    'Checkout/SqPost',  
    async (tableBody, { rejectWithValue }) => {
      try {
        const response = await apiClient.post('CheckoutPage/InsertSalesQuotation',tableBody);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error Posting Data');
      }
    }
  );

  export const UpdateSalesQuotation = createAsyncThunk(
    'Checkout/UpdateSq',  
    async (tableBody, { rejectWithValue }) => {
      try {
        const response = await apiClient.post('CheckoutPage/updateSaleQuotation',tableBody);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error Posting Data');
      }
    }
  );



